const crypto = require('crypto'); 
const moment = require('moment'); 
// import moment from 'moment';

const mra=()=>{ 
    const terminalActivationCode = "ee4a0748-9634-4ab9-851d-7604922561b7";
    const secretKey = "742a75f19134a1048497bcb197b1e012535a76e";
    const hash = crypto.createHmac('sha512',secretKey)
    .update(terminalActivationCode).digest('base64')
    return hash
}
const BASE64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

/**
 * Converts a Base10 number (or string) to the specific Base64 format required by MRA.
 */
const base10ToBase64=(number)=> {
  if (!number || isNaN(number)) {
    return null
  }
  let n = BigInt(number);
  if (n === 0n) return "A";
  
  let result = "";
  while (n > 0n) {
    let remainder = Number(n % 64n);
    result = BASE64_CHARS[remainder] + result;
    n = n / 64n;
  }
  return result;
}

/**
 * Calculates the Julian Date as per the MRA algorithm.
 */

const toJulianDate=(dateString)=> {
  const date = new Date(dateString);
  let year = date.getFullYear();
  let month = date.getMonth() + 1; // JavaScript months are 0-indexed
  let day = date.getDate();

  if (month <= 2) {
    year -= 1;
    month += 12;
  }

  const A = Math.floor(year / 100);
  const B = 2 - A + Math.floor(A / 4);

  const JD = Math.floor(365.25 * (year + 4716)) +
             Math.floor(30.6001 * (month + 1)) +
             day + B - 1524;
  return JD;
}

/**
 * Reverses the MRA Julian Date algorithm to return a date string.
 */
const fromJulianDate = (jd) => {
  let f = jd + 1524;
  let a = Math.floor((f - 122.1) / 365.25);
  let b = Math.floor(365.25 * a);
  let c = Math.floor((f - b) / 30.6001);

  let day = Math.floor(f - b - Math.floor(30.6001 * c));
  let month = (c < 14) ? (c - 1) : (c - 13);
  let year = (month > 2) ? (a - 4716) : (a - 4715);

  // Formatting month and day with leading zeros for standard YYYY-MM-DD
  const pad = (n) => n.toString().padStart(2, '0');
  return `${year}-${pad(month)}-${pad(day)}`;
};
 

// Base64 to Base10 (Inverse)
const base64ToBase10 = (b64String) => {
  let result = 0n;
  for (let i = 0; i < b64String.length; i++) {
    // Find the index of the character in your custom alphabet
    const charIndex = BigInt(BASE64_CHARS.indexOf(b64String[i]));
    
    // Add to result, shifting by power of 64
    result = result * 64n + charIndex;
  }
  return Number(result); // Use Number() if values are small, or keep as BigInt
};

/**
 * 3. URL-Safe HMAC-SHA256 (MRA Standard for Offline)
 */
function computeHMAC256(plainText, secretKey) {
    const hmac = crypto.createHmac('sha256', secretKey);
    hmac.update(plainText, 'utf8');
    
    // MRA requires Base64 with URL-safe character swaps and no padding
    return hmac.digest('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}

/**
 * Generates the final Invoice Number string.
 */
const generateInvoiceNumber = ({ taxpayerId, terminalPosition, transactionDate, transactionCount })=> {
  const julianDate = toJulianDate(transactionDate);

  const b64Taxpayer = base10ToBase64(taxpayerId);
  const b64Position = base10ToBase64(terminalPosition);
  const b64Julian = base10ToBase64(julianDate);
  const b64Count = base10ToBase64(transactionCount);

  return `${b64Taxpayer}-${b64Position}-${b64Julian}-${b64Count}`;
}
const getItemRateInfo = (rates,item,input_exports) => {
  // const rateId = item.taxRateId?item.taxRateId:item.tax_group_code?item.tax_group_code:"A"
  const rateId =input_exports?"B": ((item.tax_group_code?item.tax_group_code:item.taxRateId)||"A")
  const rateObj = rates?.find(r => r.id === rateId);  
  return {
    ...rateObj,
    percentage: rateObj ? parseFloat(rateObj.rate) : 0,
    id: rateId
  };
};
const calculateVAT =  (payload)=>{ 
    const {items,till,totalDiscount=0,taxrates,settings,input_exports}= payload || {};
    const itemSize = items?.length
    const sharedDiscount = totalDiscount/itemSize
    const eis = till.eis_terminal;
    const configuration = eis?.configuration
    const latest_configuration = eis?.latest_configuration
    const eis_config = latest_configuration?latest_configuration:configuration

    const officialRates = eis_config?.globalConfiguration?.taxrates || taxrates; 
    let invoiceTotal = 0;
    let totalVAT = 0;
    let TotalItemsDiscount = 0;
    const taxGroups = {};
    const invoiceLineItems =  items?.map((item, index) => {
        const qty = parseFloat(item.quantity) || 1;
        const price = parseFloat(item.sold_price) || 0;
        const disc = parseFloat(item.discount) || 0;
        const itemDiscount = Number((disc*qty).toFixed(2)) 
        const totalItemDiscount = itemDiscount+sharedDiscount
        const lineTotal = (price * qty) - totalItemDiscount;
        
        const rate = getItemRateInfo(officialRates,item,input_exports);
        const lineVAT = lineTotal - (lineTotal / (1 + (rate?.percentage / 100)));

        invoiceTotal += lineTotal;
        totalVAT += lineVAT;
        TotalItemsDiscount += totalItemDiscount;

        // const rateId = item.taxRateId?item.taxRateId:item.tax_group_code?item.tax_group_code:"A"
        const rateId = input_exports?"B":((item.tax_group_code?item.tax_group_code:item.taxRateId)||"A")
        if (!taxGroups[rateId]) {
          taxGroups[rateId] = {...rate, taxableAmount: 0, taxAmount: 0 };
        }
        taxGroups[rateId].taxableAmount += lineTotal;
        taxGroups[rateId].taxAmount += lineVAT;

        return {
          ...item,
          rateId,
          id: index,
          productCode: item.productCode || item.code,
          description: item.productName || item.name,
          unitPrice: price,
          quantity: qty,
          discount: disc,
          totalItemDiscount,
          total: Number(lineTotal.toFixed(2)),
          totalVAT: Number(lineVAT.toFixed(2)), 
          isEIS: true,
          
        };
    }); 
    return {
      input_exports,
      items:invoiceLineItems,
      summary: {
        taxBreakDown: Object.keys(taxGroups)?.map(rateId => ({
            ...taxGroups[rateId],
            rateId: rateId,
            taxableAmount: Number(taxGroups[rateId].taxableAmount.toFixed(2)-taxGroups[rateId].taxAmount.toFixed(2)),
            taxAmount: Number(taxGroups[rateId].taxAmount.toFixed(2))
        })),
        levyBreakDown: [],
        totalVAT: Number(totalVAT.toFixed(2)),
        invoiceTotal: Number(invoiceTotal.toFixed(2)),
        TotalItemsDiscount:TotalItemsDiscount
        
      }  
    };
}
const generateInvoicePayload = (till, order, paymentMethod = 'Cash',isProduction,input_exports)=>{ 
    const eis = till.eis_terminal;
    const configuration = eis?.configuration
    const latest_configuration = eis?.latest_configuration
    const eis_config = latest_configuration?latest_configuration:configuration
    const officialRates = eis_config?.globalConfiguration?.taxrates || [];
    // const invoiceDate = new Date(Number(order.key))
    const invoiceDate = moment(Number(order.key));
    const invoiceDate_ = invoiceDate.format('YYYY-MM-DDTHH:mm:ss'); 
    const buyerName = order.buyerName
    const buyerTIN = order.buyerTIN
    const buyerAuthorizationCode = order.buyerAuthorizationCode
    const selectedItems = order.items
    const selectedItemsNum = selectedItems?.length 

    let invoiceTotal = 0;
    let totalVAT = 0;
    const taxGroups = {};
    const invoiceLineItems = selectedItems?.map((item, index) => {
        const qty = parseFloat(item.quantity) || 1;
        const price = parseFloat(item.sold_price) || 0;
        const disc = parseFloat(item.discount) || 0;
        const lineTotal = (price * qty) - disc;
        // const lineTotal = (price - disc) * qty;
 
        const rate = getItemRateInfo(officialRates,item,input_exports);
        const lineVAT = lineTotal - (lineTotal / (1 + (rate?.percentage / 100)));
  
        invoiceTotal += lineTotal;
        totalVAT += lineVAT;

        // const rateId = item.taxRateId?item.taxRateId:item.tax_group_code?item.tax_group_code:"A"
        const rateId = input_exports?"B":((item.tax_group_code?item.tax_group_code:item.taxRateId)||"A")

        if (!taxGroups[rateId]) {
          taxGroups[rateId] = {...rate, taxableAmount: 0, taxAmount: 0 };
        }
        taxGroups[rateId].taxableAmount += lineTotal;
        taxGroups[rateId].taxAmount += lineVAT;

        return {
          id: index,
          productCode: item.productCode || item.code,
          description: item.productDescription || item.name,
          unitPrice: price,
          quantity: qty,
          discount: disc,
          total: Number(lineTotal.toFixed(2)),
          totalVAT: Number(lineVAT.toFixed(2)),
          taxRateId: rateId,
          isProduct:item.isProduct?true:false
        };
    });
    const invoiceDetail = { 
        taxpayerId:eis?.activatedTerminal?.taxpayerId, 
        terminalPosition:eis?.activatedTerminal?.terminalPosition,  
        transactionDate:invoiceDate_, 
        transactionCount:order.eis_day_invoice_number
    } 
    const offlineDetail = { 
      data:{
        taxpayerId:eis?.activatedTerminal?.taxpayerId, 
        terminalPosition:eis?.activatedTerminal?.terminalPosition,  
        transactionCount:order.eis_day_invoice_number,
        transactionDate:invoiceDate_, 
        numItems:selectedItemsNum,
        invoiceTotal: invoiceTotal,
        vatAmount: totalVAT
      },
      secretKey:eis?.activatedTerminal?.terminalCredentials?.secretKey,  
      
    } 
    const invoiceNumber = generateInvoiceNumber(invoiceDetail);
    const offlineReceipt = generateOfflineReceipt(offlineDetail.data,offlineDetail.secretKey,isProduction);
    const online = hasOffline=>{
      const offlineSignature = offlineReceipt?.offlineSignature 
      return {
        invoiceHeader: {
          invoiceNumber: invoiceNumber,
          invoiceDateTime: invoiceDate_,
          sellerTIN: eis_config?.taxpayerConfiguration?.tin,
          buyerTIN:buyerTIN?buyerTIN:null,
          buyerName:buyerName?buyerName:null,
          buyerAuthorizationCode:buyerAuthorizationCode?buyerAuthorizationCode:null,
          siteId: eis_config?.terminalConfiguration?.terminalSite?.siteId,
          // VERSIONS FROM IMAGE:
          globalConfigVersion: eis_config?.globalConfiguration?.versionNo || 1,
          taxpayerConfigVersion: eis_config?.taxpayerConfiguration?.versionNo || 1,
          terminalConfigVersion: eis_config?.terminalConfiguration?.versionNo || 1,
          isExport:input_exports?input_exports:false,
          isReliefSupply: false,
          paymentMethod: paymentMethod
        },
        invoiceLineItems,
        invoiceSummary: {
          taxBreakDown: Object.keys(taxGroups)?.map(rateId => ({
            ...taxGroups[rateId],
              rateId: rateId,
              taxableAmount: Number(taxGroups[rateId].taxableAmount.toFixed(2)-taxGroups[rateId].taxAmount.toFixed(2)),
              taxAmount: Number(taxGroups[rateId].taxAmount.toFixed(2))
          })),
          levyBreakDown: [],
          totalVAT: Number(totalVAT.toFixed(2)),
          offlineSignature:hasOffline?offlineSignature:"", 
          invoiceTotal: Number(invoiceTotal.toFixed(2))
        } 
      }
    }
    return {
      online:online(false),
      off_online:online(true),
      offline:offlineReceipt
    };
}
const decryptInvoiceNumber = (invoiceNumber) => {
  if(!invoiceNumber){return null}
  // 1. Split the string by the hyphen delimiter
  const [b64Taxpayer, b64Position, b64Julian, b64Count] = invoiceNumber.split('-');

  // 2. Convert segments back to base 10
  const taxpayerId = base64ToBase10(b64Taxpayer);
  const terminalPosition = base64ToBase10(b64Position);
  const julianDate = base64ToBase10(b64Julian);
  const transactionCount = base64ToBase10(b64Count);

  // 3. Convert the Julian Date back to a readable date
  const transactionDate = fromJulianDate(julianDate);

  return {
    taxpayerId,
    terminalPosition,
    transactionDate,
    transactionCount
  };
};
/**
 * Generates the offline signature and QR Code URL
 * @param {Object} data - Contains taxpayerId, terminalPosition, transactionCount, date, total, vat, numItems
 * @param {String} secretKey - The terminal's secret key from Firebase
 * @param {Boolean} isProduction - Toggle for prod/dev URL
 */
function generateOfflineReceipt(data, secretKey, isProduction = false) {
    const { 
        taxpayerId, 
        terminalPosition, 
        transactionCount, 
        transactionDate, 
        numItems, 
        invoiceTotal, 
        vatAmount 
    } = data;

    // 1. Calculate Julian Date
    const julianDate = toJulianDate(transactionDate);
    const julianDateTo64 = base10ToBase64(julianDate);

    // 2. Generate the "TI" (Terminal Invoice) Combined String
    // Format: Base64(TaxpayerID)-Base64(Position)-Base64(JulianDate)-Base64(Count)
    const combinedString = [
        base10ToBase64(taxpayerId),
        base10ToBase64(terminalPosition),
        julianDateTo64,
        base10ToBase64(transactionCount)
    ].join('-');

    // 3. Prepare Parameter String for signing
    // Order matters: TI, N (items), I (total), V (VAT), T (Date)
    const params = `TI=${combinedString}&N=${numItems}&I=${invoiceTotal}&V=${vatAmount}&T=${julianDateTo64}`;

    // 4. Compute Signature
    const offlineSignature = computeHMAC256(params, secretKey);

    // 5. Build Validation URL
    const portalBase = isProduction 
        ? "https://eis-portal.mra.mw/ReceiptValidation/Validate/" 
        : "https://dev-eis-portal.mra.mw/ReceiptValidation/Validate/";

    const validationURL = `${portalBase}?${params}&S=${offlineSignature}`;

    return {
        invoiceNumber: combinedString, // This IS your offline invoice number
        offlineSignature: offlineSignature,
        validationURL: validationURL
    };
}
 

module.exports = { 
    mra,
    toJulianDate,
    generateInvoiceNumber,
    getItemRateInfo,
    generateInvoicePayload,
    generateOfflineReceipt,
    calculateVAT,
    decryptInvoiceNumber
};